import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useFactSheetStore = defineStore({
    id: 'factSheet',
    state: () => ({
        searchTerm: '',
        eggDescList: [
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'alcoholConsumption', imgFormat: 'png' },
                id: 'factSheetAlcoholConsumption',
                label: 'factSheet.alcoholConsumption'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'breastCancer', imgFormat: 'png' },
                id: 'factSheetBreastCancer',
                label: 'factSheet.breastCancer'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'cervicalCancer', imgFormat: 'png' },
                id: 'factSheetCervicalCancer',
                label: 'factSheet.cervicalCancer'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'estimatedCholesterolContentChart', imgFormat: 'png' },
                id: 'factSheetCholesteral',
                label: 'factSheet.cholesteral'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'colorectalCancer', imgFormat: 'png' },
                id: 'factSheetColorectalCancer',
                label: 'factSheet.colorectalCancer'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'cornonaryArteryDisease', imgFormat: 'png' },
                id: 'factSheetCornonaryArteryDisease',
                label: 'factSheet.cornonaryArteryDisease'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'diabetesMellitus', imgFormat: 'png' },
                id: 'factSheetDiabetesMellitus',
                label: 'factSheet.diabetesMellitus'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'fattyLiver', imgFormat: 'png' },
                id: 'factSheetFattyLiver',
                label: 'factSheet.fattyLiver'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'gout', imgFormat: 'png' },
                id: 'factSheetGout',
                label: 'factSheet.gout'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'hazardsOfSmoking', imgFormat: 'png' },
                id: 'factSheetHazardsOfSmoking',
                label: 'factSheet.hazardsOfSmoking'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'hepatitisA', imgFormat: 'png' },
                id: 'factSheetHepatitisA',
                label: 'factSheet.hepatitisA'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'hepatitisB', imgFormat: 'png' },
                id: 'factSheetHepatitisB',
                label: 'factSheet.hepatitisB'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'hypertension', imgFormat: 'png' },
                id: 'factSheetHypertension',
                label: 'factSheet.hypertension'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'obesity', imgFormat: 'png' },
                id: 'factSheetObesity',
                label: 'factSheet.obesity'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'osteoporosis', imgFormat: 'png' },
                id: 'factSheetOsteoporosis',
                label: 'factSheet.osteoporosis'
            },
            {
                eggIconObj: { componentName: 'factsheet', imgName: 'prostateCancer', imgFormat: 'png' },
                id: 'factSheetProstateCancer',
                label: 'factSheet.prostateCancer'
            },
        ],
        filteredItems: [],
        alcoholConsumptionImmediateEffectsList1: [
            { label: 'factSheet.tranquillizing' },
            { label: 'factSheet.disinhibition' },
            { label: 'factSheet.concentrationImpairment' },
            { label: 'factSheet.judgementImpairment' },
            { label: 'factSheet.slowingReflexes' },
            { label: 'factSheet.slowingReactionTime' },
            { label: 'factSheet.coordinationImpairment' },
        ],
        alcoholConsumptionImmediateEffectsList2: [
            { label: 'factSheet.headache' },
            { label: 'factSheet.slurringOfSpeech' },
            { label: 'factSheet.drowsiness' },
            { label: 'factSheet.alteredEmotions' },
            { label: 'factSheet.vomiting' },
            { label: 'factSheet.breathingDifficulties' },
            { label: 'factSheet.unconsciousness' },
            { label: 'factSheet.unconsciousness' },
        ],
        alcoholConsumptionLongTermEffectsList: [
            {
                label: 'factSheet.heart',
                list: [
                    'factSheet.highbloodPressure',
                    'factSheet.heartFailure',
                ]
            },
            {
                label: 'factSheet.brain',
                list: [
                    'factSheet.stroke',
                    'factSheet.memoryLoss',
                ]
            },
            {
                label: 'factSheet.liver',
                list: [
                    'factSheet.liverCancer',
                    'factSheet.cirrhosis',
                    'factSheet.fattyLiver1',
                ]
            },
            {
                label: 'factSheet.breasts',
                list: [
                    'factSheet.breastCancer',
                ]
            },
            {
                label: 'factSheet.mouthAndGut',
                list: [
                    'factSheet.oralCancer',
                    'factSheet.colorectalCancer1',
                    'factSheet.actuteAndChronicGastritis',
                    'factSheet.gastricUlcers',
                ]
            },
            {
                label: 'factSheet.sexOrganAndFunction',
                list: [
                    'factSheet.impotence',
                    'factSheet.impairedSpermGrowth',
                    'factSheet.loweredFertilityInWomen',
                ]
            },
            {
                label: 'factSheet.nutrition',
                list: [
                    'factSheet.malnutritionEg',
                    'factSheet.deficiency',
                    'factSheet.obesity',
                ]
            },
            {
                label: 'factSheet.mind',
                list: [
                    'factSheet.depression',
                    'factSheet.anxiety',
                    'factSheet.insomnia',
                ]
            },
        ],
        breastCancerHighRiskFactorsList: [
            { label: 'factSheet.highRiskFactors' },
            { label: 'factSheet.highRiskFactorsGender' },
            { label: 'factSheet.highRiskFactorsAge' },
            { label: 'factSheet.highRiskFactorFamilyHistory' },
            { label: 'factSheet.highRiskFactorMenstrualCycle' },
            { label: 'factSheet.highRiskFactorChildbirth' },
            { label: 'factSheet.highRiskFactorDiet' },
            { label: 'factSheet.highRiskFactorDrugs' },
            { label: 'factSheet.highRiskFactorPersonalHistory' },
        ],
        breastCancerBreastSymptomsList: [
            { label: 'factSheet.lumpOfAnySize' },
            { label: 'factSheet.changesInShapeOfSize' },
            { label: 'factSheet.dimplingOnSkin' },
            { label: 'factSheet.veinCongestion' },

        ],
        breastCancerNippleSymptomsList: [
            { label: 'factSheet.lumpOfAnySize' },
            { label: 'factSheet.changesInShapeOfSize' },
            { label: 'factSheet.dimplingOnSkin' },
            { label: 'factSheet.veinCongestion' },
        ],
        breastCancerArmpitSymptomsList: [
            { label: 'factSheet.lumpOfAnySize' },
            { label: 'factSheet.changesInShapeOfSize' },
            { label: 'factSheet.dimplingOnSkin' },
            { label: 'factSheet.veinCongestion' },
        ],
        breastCancerSurgeryTypeList: [
            { label: 'factSheet.typeOfSurgery1' },
            { label: 'factSheet.typeOfSurgery2' },
        ],
        cervicalCancerRiskFactorsList: [
            { label: 'factSheet.multipleSexusalPartners' },
            { label: 'factSheet.sexualIntercourse' },
            { label: 'factSheet.coinfectionWith' },
            { label: 'factSheet.smoking' },
            { label: 'factSheet.weakendedImmunity' },
            { label: 'factSheet.longTermUseOfOralContraceptivePills' },
            { label: 'factSheet.highNumberOfChildBirths' },
        ],
        cervicalCancerPreventionList: [
            { label: 'factSheet.receiveHPV' },
            { label: 'factSheet.practiseSaferSex' },
            { label: 'factSheet.doNoSmoke' },
        ],
        cervicalCancerSymptomsList: [
            { label: 'factSheet.betweenPeriods' },
            { label: 'factSheet.duringOrAfterSex' },
            { label: 'factSheet.afterMenopause' },
        ],
        cervicalCancerOtherSymptomsList: [
            { label: 'factSheet.foulSmelling' },
            { label: 'factSheet.pelvicPain' },
            { label: 'factSheet.bloodInUrine' },
            { label: 'factSheet.legSwelling' },
            { label: 'factSheet.generalTiredness' },
        ],
        cervicalCancerCervicalScreeningList: [
            { label: 'factSheet.womanAged25SexualExp' },
            { label: 'factSheet.womanAged30SexualExp', list: ['factSheet.cytologyEvery3Years', 'factSheet.HPVTesting', 'factSheet.coTesting'] },
            { label: 'factSheet.womanAged65SexualExp', list: ['factSheet.mayDiscontinueScreening', 'factSheet.shouldBeScreened'] },
        ],
        cholesteralDietaryAdvicesList: [
            {
                desc: 'factSheet.dietaryAdvicesDesc1',
                tableTitle: ['factSheet.typeOfBloodCholesterol', 'factSheet.desirableLevels'],
                tableContent: [
                    {
                        label: 'factSheet.animalBasedSaturatedFat',
                        desc: 'factSheet.familyMeat'
                    },
                    {
                        label: 'factSheet.plantBasedSatursatedFat',
                        desc: 'factSheet.palmOil'
                    },
                    {
                        label: 'factSheet.transFat',
                        desc: 'factSheet.hardMargarine'
                    },
                ]
            },
            {
                desc: 'factSheet.dietaryAdvicesDesc2',
                list: ['factSheet.consumptionOfDietaryCholesterol', 'factSheet.healthyIndividuals', 'factSheet.hyperlipidemia'],
            },
            {
                desc: 'factSheet.dietaryAdvicesDesc3'
            },
            {
                desc: 'factSheet.dietaryAdvicesDesc4',
                tableTitle: ['factSheet.sourceOfUnsaturedFat', 'factSheet.examples'],
                tableContent: [
                    {
                        label: 'factSheet.vegetableOils',
                        desc: 'factSheet.oliverOil'
                    },
                    {
                        label: 'factSheet.seeds',
                        desc: 'factSheet.sesame'
                    },
                    {
                        label: 'factSheet.nuts',
                        desc: 'factSheet.walnuts'
                    },
                    {
                        label: 'factSheet.fruits',
                        desc: 'factSheet.avocados'
                    },
                ]
            },
        ],
        cholesteralHealthyLifestyleList: [
            { label: 'factSheet.maintainIdealBodyWeight' },
            { label: 'factSheet.exerciseRegularly' },
            { label: 'factSheet.doNotSmoke' },
            { label: 'factSheet.drinkFollowDoctorAdvice' },
            { label: 'factSheet.takeCholesterol' },
            { label: 'factSheet.individualsWithFamilyHistory' },
        ],
        colorectalRiskFactorsList: [
            { label: 'factSheet.mentAbove50' },
            { label: 'factSheet.haveHereditaryBowelDiseases' },
            { label: 'factSheet.persistentInflammation' },
            { label: 'factSheet.historyOfColonicPolyps' },
            { label: 'factSheet.familyHistoryOfColorectalCancer' },
        ],
        colorectalSignsAndSymptomsList: [
            { label: 'factSheet.changeInBowelHabits' },
            { label: 'factSheet.bloorOrMucus' },
            { label: 'factSheet.persistentUrge' },
            { label: 'factSheet.abdominalDiscomfort' },
        ],
        colorectalPreventionList: [
            { label: 'factSheet.eatMoreFoodRichInFibre' },
            { label: 'factSheet.decreaseConsumption' },
            { label: 'factSheet.doAdequatePhysicalActivity' },
            { label: 'factSheet.maintainHealthyBodyWeight' },
            { label: 'factSheet.abstainFromAlcoholDrinking' },
        ],
        colorectalScreeningList: [
            { label: 'factSheet.annualOrBientialFascal' },
            { label: 'factSheet.sigmoidoscopy5' },
            { label: 'factSheet.colonoscopy10' },
        ],
        goutList: [
            { label: 'factSheet.eatBalancedDiet' },
            { label: 'factSheet.avoidAlcoholicBeverages' },
            { label: 'factSheet.stayWellHydrated' },
            { label: 'factSheet.maintainAnOptimalWeightFor' },
            { label: 'factSheet.bePhysicallyActive' },
            { label: 'factSheet.takeMedicationsAsPrescribed' },
        ],
        goutImmediateEffectsList: [
            { label: 'factSheet.highPurinefoods', list: ['factSheet.offal', 'factSheet.oilyFish', 'factSheet.seafood', 'factSheet.gameRabbit', 'factSheet.meatAndYeastExtracts'] },
            { label: 'factSheet.mediumPurineFoods', list: ['factSheet.meatBeef', 'factSheet.poultry', 'factSheet.driedPeas', 'factSheet.mushrooms', 'factSheet.someVegetables', 'factSheet.wholegrains'] },
            { label: 'factSheet.lowPurineFoods', list: ['factSheet.dietaryProducts', 'factSheet.eggs', 'factSheet.breadAndCereals', 'factSheet.ricePasta', 'factSheet.fruitAndVegetables'] },
            { label: 'factSheet.maintainAnOptimalWeightFor', list: ['factSheet.offal', 'factSheet.oilyFish', 'factSheet.seafood', 'factSheet.gameRabbit', 'factSheet.meatAndYeastExtracts'] },
        ],
        hazardsOfSmokingWhoFindsList: [
            { label: 'factSheet.singleLargestPreventable' },
            { label: 'factSheet.keyFactorInHeartDisease' },
            { label: 'factSheet.causeCancerOfTheLungs' },
            { label: 'factSheet.affectsWomen' },
        ],
        hazardsOfSmokingMajorIngrediantsList: [
            { label: 'factSheet.nicotine', desc: 'factSheet.nicotineDesc' },
            { label: 'factSheet.carbonMonxide', desc: 'factSheet.carbonMonxideDesc' },
            { label: 'factSheet.tar', desc: 'factSheet.tarDesc' },
        ],
        hazardsOfSmokingPreparationList: [
            { label: 'factSheet.clearAboutReasons' },
            { label: 'factSheet.setAQuitDay' },
            { label: 'factSheet.tryToCutDown' },
        ],
        hazardsOfSmokingQuitDayList: [
            { label: 'factSheet.refrainFromSmoking' },
            { label: 'factSheet.discardAllCigaretts' },
            { label: 'factSheet.avoidStayingInSmoke' },
            { label: 'factSheet.offerCigaretteQuit' },
        ],
        hepatitisAClinicalFeatureList: [
            { label: 'factSheet.fever' },
            { label: 'factSheet.malaise' },
            { label: 'factSheet.lossOfAppetite' },
            { label: 'factSheet.diarrhoea' },
            { label: 'factSheet.nausea' },
            { label: 'factSheet.abdominalDiscomfort2' },
            { label: 'factSheet.jaundice' },
        ],
        hepatitisAPreventionList: [
            { label: 'factSheet.adequateSupplies' },
            { label: 'factSheet.foodSafetyPractice' },
            { label: 'factSheet.properDisposal' },
        ],
        hepatitisAImprovedSanitationList: [
            { label: 'factSheet.maintainGoodPersonalHygiene', list: ['factSheet.performHandHygieneFrequently', 'factSheet.wearGloves', 'factSheet.useSErvingChopsticks', 'factSheet.refrainFromWorkOrSchool', 'factSheet.excludeInfectedPersons'] },
            { label: 'factSheet.maintainGoodEnviro', list: ['factSheet.keepThePremises', 'factSheet.householdDetergent', 'factSheet.useAbsorbentDisposableTowels'] },
            { label: 'factSheet.maintainGoodFoodHygiene', list: ['factSheet.adopt5Keys', 'factSheet.drinkOnlyBoiledWater', 'factSheet.avoidDrinksWithIce', 'factSheet.purchaseFreshFood', 'factSheet.eatOnlyThoroughlyCookedFood', 'factSheet.cleanAndWashFoodThoroughly', 'factSheet.heatingToAnInternalTemperature', 'factSheet.havingHotpot'] },
            { label: 'factSheet.hepatitisAVaccination', desc: 'factSheet.hepatitisAVaccinationDesc', list: ['factSheet.travellersToEndemic', 'factSheet.personsWithClotting', 'factSheet.personsWithChronicLiverDiseases', 'factSheet.menWhoHaveSexWithMen'] },
        ],
        hepatitisAVaccinationList: [
            { label: 'factSheet.travellersToEndemic' },
            { label: 'factSheet.personsWithClotting' },
            { label: 'factSheet.personsWithChronicLiverDiseases' },
            { label: 'factSheet.menWhoHaveSexWithMen' },
        ],
        ideaBodyWeightList: [
            { height: 1.45, idealWeightRange: '38.8 - 48.1' },
            { height: 1.5, idealWeightRange: '41.6 - 51.5' },
            { height: 1.55, idealWeightRange: '44.4 - 55.0' },
            { height: 1.6, idealWeightRange: '47.4 - 58.6' },
            { height: 1.65, idealWeightRange: '50.4 - 62.3' },
            { height: 1.7, idealWeightRange: '53.5 - 66.2' },
            { height: 1.75, idealWeightRange: '56.7 - 70.1' },
            { height: 1.8, idealWeightRange: '59.9 - 74.2' },
            { height: 1.85, idealWeightRange: '63.3 - 78.4' },
            { height: 1.9, idealWeightRange: '66.8 - 82.7' },
        ],
        obesityDiseaseList: [
            { label: 'factSheet.stroke' },
            { label: 'factSheet.highBloodPressure' },
            { label: 'factSheet.heartDisease' },
            { label: 'factSheet.gallstones' },
            { label: 'factSheet.diabetes' },
            { label: 'factSheet.gout' },
            { label: 'factSheet.sleepApnea' },
            { label: 'factSheet.breastCancer' },
            { label: 'factSheet.highCholesterol' },
            { label: 'factSheet.colorectalCancer' },
            { label: 'factSheet.osteoarthritisOfTheKnee' },
            { label: 'factSheet.varicoseVeins' },
        ],
        obesityIdealWeightList: [
            { label: 'factSheet.EatABalancedDiet', desc: 'factSheet.EatABalancedDietDesc', list: ['factSheet.purcahseDiffTypesOfFood', 'factSheet.avoidHighFatIngrediants', 'factSheet.reduceYourIntake', 'factSheet.avoidFoodsAndBeverages', 'factSheet.useLowFatCookigMethods', 'factSheet.eatThreeRegularMeals'] },
            { label: 'factSheet.regularPhysicalActivity', desc: 'factSheet.regularPhysicalActivityDesc' },
        ],
        osteoporosisHigherRiskList: [
            { label: 'factSheet.elders' },
            { label: 'factSheet.femaleOsteoporosis' },
            { label: 'factSheet.smallFrame' },
            { label: 'factSheet.havingFamilyHistory', },
            { label: 'factSheet.unhealthyLifestyle', list: ['factSheet.smoking', 'factSheet.inadequateCalcium', 'factSheet.inadequateD', 'factSheet.excessiveCaffeine', 'factSheet.consumeTooMuch', 'factSheet.littleExercise', 'factSheet.excessiveAlcohol'] },
            { label: 'factSheet.diseaseSuchAs', list: ['factSheet.estrogenDeficiency', 'factSheet.estosteroneDeficiency', 'factSheet.endocrineDiseases'] },
            { label: 'factSheet.medications', },
        ],
        osteoporosisKnowList: [
            { label: 'factSheet.dualEnergyXRay' },
            { label: 'factSheet.quantitativeUltrasound' },
        ],
        osteoporosisBalancedDietList: [
            { label: 'factSheet.balancedDiet3', list: ['factSheet.calciumRicchFoods', 'factSheet.darkGreenLeafyVegs', 'factSheet.nutsEg', 'factSheet.adquateVitD', 'factSheet.avoidSaltyFood'] },
            { label: 'factSheet.dontSmoke' },
            { label: 'factSheet.performWeightBearing' },
            { label: 'factSheet.performOutdoorActivities', },
        ],
        osteoporosisBalancedDietChineseList: [
            { label: 'factSheet.balancedDiet3', list: ['factSheet.calciumRicchFoods', 'factSheet.milkEg', 'factSheet.seafoodEg', 'factSheet.soybeanEg', 'factSheet.vegsEg', 'factSheet.nutsEg', 'factSheet.adequateVitanimD', 'factSheet.avoidSaltyFood'] },
            { label: 'factSheet.dontSmoke' },
            { label: 'factSheet.performWeightBearing' },
            { label: 'factSheet.performOutdoorActivities', },
        ],
        prostateCancerFactList: [
            { label: 'factSheet.accuracyOfDre', list: ['factSheet.5outOf6', 'factSheet.1outOf2'] },
            { label: 'factSheet.increasePSA', list: ['factSheet.3outOf4', 'factSheet.1outOf4'] },
        ],
    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useFactSheetStore, import.meta.hot));
}

export { useFactSheetStore };
